import { Link } from "react-router-dom";
import { AppHeader } from "@/components/AppHeader";
import { useAuth } from "@/context/AuthContext";
import { Cpu, BookOpen, Calculator, ArrowRight } from "lucide-react";

const SUBJECTS = [
  {
    id: "computer",
    name: "Computer",
    tagline: "Java, OOP, Logic & Algorithms",
    Icon: Cpu,
    color: "hsl(200 90% 50%)",
    bg: "from-[hsl(200_90%_50%)]/10 to-[hsl(200_90%_50%)]/5",
  },
  {
    id: "english",
    name: "English",
    tagline: "Literature, Grammar & Composition",
    Icon: BookOpen,
    color: "hsl(10 85% 62%)",
    bg: "from-[hsl(10_85%_62%)]/10 to-[hsl(40_95%_58%)]/10",
  },
  {
    id: "mathematics",
    name: "Mathematics",
    tagline: "Numbers, Geometry, Algebra & Trig",
    Icon: Calculator,
    color: "hsl(260 70% 60%)",
    bg: "from-[hsl(260_70%_60%)]/10 to-[hsl(285_70%_60%)]/5",
  },
];

export default function SubjectsPage() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen">
      <AppHeader />
      <main className="max-w-6xl mx-auto px-6 py-12">
        <div className="mb-12">
          <div className="text-sm font-bold uppercase tracking-widest text-[hsl(var(--brimi-coral))] mb-3">
            Hi {user?.name?.split(" ")[0]} 👋
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight mb-3">
            What are we learning today?
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl">
            Pick a subject to get started. Each subject has chapters for
            classes IX through XII.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SUBJECTS.map(({ id, name, tagline, Icon, color, bg }) => (
            <Link
              key={id}
              to={`/subjects/${id}/classes`}
              data-testid={`subject-card-${id}`}
              className={`group relative tactile-card p-8 md:p-10 bg-gradient-to-br ${bg} overflow-hidden`}
            >
              <div
                className="absolute -top-10 -right-10 w-48 h-48 rounded-full opacity-20 blur-2xl"
                style={{ background: color }}
              />
              <div className="relative">
                <div
                  className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 transition-transform group-hover:rotate-6"
                  style={{ background: color, color: "white" }}
                >
                  <Icon className="w-8 h-8" />
                </div>
                <div className="text-xs uppercase tracking-widest text-muted-foreground font-bold mb-2">
                  Subject
                </div>
                <h2 className="text-4xl font-black tracking-tight mb-2">
                  {name}
                </h2>
                <p className="text-muted-foreground mb-8">{tagline}</p>
                <div
                  className="inline-flex items-center gap-2 font-bold text-sm group-hover:gap-3 transition-all"
                  style={{ color }}
                >
                  Choose your class <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
